<template>
  <div>
    <input-field
      v-model="innerAccount"
      name="アカウント名"
      label="アカウント名"
      full-width
      rules="required"
    />
  </div>
</template>

<script>
import InputField from '@/components/fields/InputField'

export default {
  name: 'SellerCreateAccountForm',
  components: {
    InputField
  },
  props: {
    accountName: {
      type: String,
      default: null
    }
  },
  emits: ['update:accountName'],
  computed: {
    innerAccount: {
      get () {
        return this.accountName
      },
      set (value) {
        this.$emit('update:accountName', value)
      }
    }
  }
}
</script>

<style>
</style>
